import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_MSAL_CLIENT_ID;
if (!clientId || clientId === '00000000-0000-0000-0000-000000000000') {
  throw new Error('VITE_MSAL_CLIENT_ID is not configured. Set it in .env or as a build-time environment variable.');
}

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: import.meta.env.VITE_MSAL_AUTHORITY || 'https://login.microsoftonline.com/cloudteam.pl',
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Include API scope in login so consent is granted upfront
const apiScope = `api://${clientId}/access_as_user`;

export const loginRequest = {
  scopes: ['openid', 'profile', 'email', apiScope],
};

export const apiScopes = {
  scopes: [apiScope],
};
